import { MenuGroup, Section } from '@atlaskit/menu';
import { Box } from '@atlaskit/primitives';
import { type OpenThreadContextData } from '@databases/comments/context/CommentContext';
import { type DialogContextInterface } from '@databases/dialog';
import React, { useMemo } from 'react';

import { useContextMenuKeyboardShortcuts } from '../hooks/use-context-menu-keyboard-shortcuts.ts';
import { type MenuContentItemFactory } from '../select-value-menu/types.ts';

import { buildMenuSections } from './build-menu-sections.tsx';

export interface ContextMenuContentProps {
  items: MenuContentItemFactory[];
  showDialog: DialogContextInterface['showDialog'];
  setOpenThread: (value: OpenThreadContextData) => void;
}

export const ContextMenuContent: React.FC<ContextMenuContentProps> = ({
  items,
  showDialog,
  setOpenThread
}) => {
  const { sections, resolvedItems } = useMemo(
    () => buildMenuSections(items, showDialog, setOpenThread),
    [items, showDialog, setOpenThread]
  );

  useContextMenuKeyboardShortcuts(resolvedItems);

  return (
    <Box paddingBlock="space.025">
      <MenuGroup testId="database-context-menu" minWidth="248px" spacing="compact">
        {sections.map((section, index) => (
          <Section key={`section-${index}`} hasSeparator={section.hasSeparator}>
            {section.items}
          </Section>
        ))}
      </MenuGroup>
    </Box>
  );
};
